module.exports = __webpack_public_path__ + "img/hs_ev1.435b1d1b.png";